import CustomForm from './components/custom-form/CustomForm';
import CustomInput from './components/custom-input/CustomInput';
import CustomSelect from './components/custom-select/CustomSelect';
import CustomButton from './components/custom-button/CustomButton';
import CustomFormFooter from './components/custom-form-footer/CustomFormFooter';
import CustomFormLayout from './components/custom-form-layout/CustomFormLayout';

import CustomValue from './components/custom-value/CustomValue';
import CustomLabel from './components/custom-label/CustomLabel';

export {
    CustomForm,
    CustomInput,
    CustomSelect,
    CustomButton,
    CustomFormFooter,
    CustomFormLayout,
    CustomValue,
    CustomLabel
};



// WEBPACK FOOTER //
// ./src/modules/form/index.js